import { useCoverPageContext } from "../CoverPageProvider"
import { useCoverPageIsEditable } from "../access"
import { CoverPageBlankSlateKind } from "../blankSlates"

export function useCoverPageBlankSlate(kind: CoverPageBlankSlateKind) {
  const isEditable = useCoverPageIsEditable()
  const resourceIsReady = useCoverPageContext((value) => value.resourceIsReady)
  const offersAreReady = useCoverPageContext((value) => value.offersAreReady)
  const immersiveActive = useCoverPageContext((value) => value.immersiveActive)
  const missing = useCoverPageContext((value) => value.blankSlateGaps[kind])
  return !!(
    isEditable &&
    !immersiveActive &&
    resourceIsReady &&
    (kind !== "offer" || offersAreReady) &&
    missing
  )
}
